import { OmyConst } from "../../OmyConst";
import Omy from "../../Omy";

export default class OParticleContainer extends PIXI.ParticleContainer {
    constructor(maxSize = 1500, properties = null, batchSize = 16384, autoResize = false) {
        super(maxSize, properties, batchSize, autoResize);

        this._onDownEvent = "down_event";
        this._onUpEvent = "up_event";
        this._onUpOutSideEvent = "up_out_event";
        this._onOverEvent = "over_event";
        this._onOutEvent = "out_event";
        this._onDragStartEvent = "drag_start_event";
        this._onDragStopEvent = "drag_stop_event";
        this._onDragUpdateEvent = "drag_update_event";

        this.isUpdate = true;
        this.aa_isRegOnDebug = false;
        this._inDebug = false;
        /**         * @type {Object}         */
        this.userData = null;
        /**         * @type {Boolean}         */
        this._active = true;
        this.numChildren = 0;
        this._oX = 0;
        this._oY = 0;
        this._oWidth = 0;
        this._oHeight = 0;

        /**         * @type {Array}         */
        this._externalMethodParams = null;
        /**         * @type {Function}         */
        this._externalMethod = null;
        this._isDrag = false;
        this._dragVertical = false;
        this._dragHorizontal = false;
        this._isStartDrag = false;
        this._isCheckInput = false;

        this.autoReviveChildren = true;
        this.needAutoRevive = false;

        this._boundsRect = new OmyConst.Rectangle();
        this._localBoundsRect = new OmyConst.Rectangle();

        this._anchorX = 0;
        this._anchorY = 0;

        this._oType = OmyConst.OMY_PARTICLE_CONTAINER;
    }

    /**     * @public     */
    addChild(child) {
        super.addChild(child);
        this.numChildren = this.children.length;
        return child;
    }

    /**     * @public     */
    addChildAt(child, index) {
        super.addChildAt(child, index);
        this.numChildren = this.children.length;
        return child;
    }

    /**     * @public     */
    removeChild(child) {
        super.removeChild(child);
        this.numChildren = this.children.length;
        return child;
    }

    /**     * @public     */
    removeChildAt(index) {
        let child = super.removeChildAt(index);
        this.numChildren = this.children.length;
        return child;
    }

    /**     * @public     */
    removeChildren(beginIndex, endIndex) {
        let res = super.removeChildren(beginIndex, endIndex);
        this.numChildren = this.children.length;
        return res;
    }

    /**     * @public     */
    removeAll() {
        if (this.children != null) {
            while (this.children.length) {
                this.removeChildAt(0);
            }
            this.numChildren = 0;
        }
    }

    /**
     * @param {PIXI.DisplayObject} child
     * @returns {boolean}
     */
    contains(child) {
        if (this.children == null) {
            return false;
        }

        return this.children.indexOf(child) >= 0;
    }

    /**     * @public     */
    kill() {
        if (this._active) {
            this._active = false;
            if (this._isUpdate)
                Omy.removeUpdater(this.update, this);

            if (this.children != null) {
                let i = 0;
                let m = this.numChildren;
                let o;
                while (i < this.numChildren && this.numChildren) {
                    o = this.children[i++];
                    if (o.active && o.kill) {
                        o.kill();
                    }
                    if (m !== this.numChildren) {
                        m--;
                        i--;
                    }
                }
            }

            if (this.input)
                this.input = false;
            this.renderable = false;
        }

        return this;
    }

    /**     * @public     */
    revive() {
        if (!this._active) {
            this._active = true;
            this.renderable = true;
            if (this._isUpdate)
                Omy.addUpdater(this.update, this);

            if (this.children != null) {
                let i = 0;
                let o;
                while (i < this.numChildren) {
                    o = this.children[i++];
                    if ((this.autoReviveChildren || o.needAutoRevive) && !o.active && o.revive) {
                        o.revive();
                    }
                }
            }

            if (this.input)
                this.input = true;
        }

        return this;
    }

    /**     * @public     */
    destroy(options) {
        options = options || { children: true, texture: false, baseTexture: false };
        this._active = false;
        this.userData = null;
        this.numChildren = 0;
        this._boundsRect = null;
        this._localBoundsRect = null;
        this._isDrag = false;
        this._isStartDrag = false;
        if (this._listenMouseUp) {
            this._listenMouseUp = false;
            Omy.mouse.removeUpMouse(this._globalMouseUp, this);
        }
        this._eventData = null;
        this.isUpdate = false;

        if (this.input) {
            this.input = false;
        }
        this.removeAllListeners(this._onDragStartEvent);
        this.removeAllListeners(this._onDragStopEvent);
        this.removeAllListeners(this._onDragUpdateEvent);
        this.removeAllListeners(this._onDownEvent);
        this.removeAllListeners(this._onOutEvent);
        this.removeAllListeners(this._onOverEvent);
        this.removeAllListeners(this._onUpEvent);
        this.removeAllListeners(this._onUpOutSideEvent);

        this._externalMethod = null;
        this._externalMethodParams = null;
        this.renderable = false;
        this.visible = false;

        super.destroy(options);
        return this;
    }

    /**     * @public     */
    update(delta) { // eslint-disable-line
        if (this._isStartDrag) {
            if (this._eventData.global.x !== this._dragSaveX || this._eventData.global.y !== this._dragSaveY) {
                if (this._dragHorizontal) {
                    this.x = this._oX + this._eventData.global.x - this._dragSaveX;

                    if (this._oX < this._dragXMin) {
                        this.x = this._dragXMin;
                    } else if (this._oX > this._dragXMax) {
                        this.x = this._dragXMax;
                    }
                }
                if (this._dragVertical) {
                    this.y = this._oY + this._eventData.global.y - this._dragSaveY;

                    if (this._oY < this._dragYMin) {
                        this.y = this._dragYMin;
                    } else if (this._oY > this._dragYMax) {
                        this.y = this._dragYMax;
                    }
                }
                this._dragSaveX = this._eventData.global.x;
                this._dragSaveY = this._eventData.global.y;
                this.emit(this._onDragUpdateEvent, this);
                if (!Omy.mouse.isDown) this._upOutSide();
            }
        }
        if (this.aa_isRegOnDebug && !this._inDebug) {
            Omy.add.regDebugMode(this);
        } else if (!this.aa_isRegOnDebug && this._inDebug) {
            Omy.add.removeFromDebug(this);
        }
    }

    _down(event) {
        if (this._isDrag) {
            this._eventData = event.data;
            this._dragSaveX = this._eventData.global.x;
            this._dragSaveY = this._eventData.global.y;
            this._isStartDrag = true;
            this.emit(this._onDragStartEvent, this);
        }

        this.emit(this._onDownEvent, this);
    }

    _over() {
        this.emit(this._onOverEvent, this);
    }

    _out() {
        this.emit(this._onOutEvent, this);
    }

    _upOutSide() {
        this._out();
        this.emit(this._onUpOutSideEvent, this);
    }

    _up() {
        this.emit(this._onUpEvent, this);
        if (this._externalMethod != null)
            this._externalMethod.apply(null, this._externalMethodParams);
    }

    _globalMouseUp() {
        if (this._isDrag && this._isStartDrag) {
            this._eventData = null;
            this._isStartDrag = false;
            this.emit(this._onDragStopEvent, this);
        }
    }

    setXY(ax, ay) {
        this._oX = ax;
        this._oY = ay;
        this.position.set(ax, ay);
    }

    setSize(ax, ay) {
        this.width = ax;
        this.height = ay;
    }

    setScale(ax, ay) {
        this.scale.set(ax, ay);
    }

    setAnchor(ax, ay) {
        this.anchorX = ax;
        this.anchorY = ay;
    }

    setPivot(ax, ay) {
        this.pivot.set(ax, ay);
        this.x = this._oX + ax;
        this.y = this._oY + ay;
    }

    updateAnchor() {
        this.anchorX = this.anchorX;
        this.anchorY = this.anchorY;
    }

    /**
     * @param {Function}eMethod
     * @param {Array}methodParams
     */
    externalMethod(eMethod, methodParams) {
        if (!this.input)
            this.input = true;
        this._externalMethod = eMethod;
        this._externalMethodParams = methodParams;
    }

    boundsDragRect(rXMin = NaN, rYMin = NaN, rXMax = NaN, rYMax = NaN) {
        if (!isNaN(rXMin))
            this._dragXMin = rXMin;
        if (!isNaN(rYMin))
            this._dragYMin = rYMin;
        if (!isNaN(rXMax))
            this._dragXMax = rXMax;
        if (!isNaN(rYMax))
            this._dragYMax = rYMax;
    }

    addOver(func, context, once) {
        if (!this.input)
            this.input = true;
        this._addNewEvent(this._onOverEvent, func, context, once);
    }

    addOut(func, context, once) {
        if (!this.input)
            this.input = true;
        this._addNewEvent(this._onOutEvent, func, context, once);
    }

    addDown(func, context, once) {
        if (!this.input)
            this.input = true;
        this._addNewEvent(this._onDownEvent, func, context, once);
    }

    addUp(func, context, once) {
        if (!this.input)
            this.input = true;
        this._addNewEvent(this._onUpEvent, func, context, once);
    }

    addUpOutSide(func, context, once) {
        if (!this.input)
            this.input = true;
        this._addNewEvent(this._onUpOutSideEvent, func, context, once);
    }

    addDragUpdate(func, context, once) {
        this._addNewEvent(this._onDragUpdateEvent, func, context, once);
    }

    addDragStart(func, context, once) {
        this._addNewEvent(this._onDragStartEvent, func, context, once);
    }

    addDragStop(func, context, once) {
        this._addNewEvent(this._onDragStopEvent, func, context, once);
    }

    /**     * @private     */
    _addNewEvent(event, func, context, once = false) {
        if (once)
            this.once(event, func, context);
        else
            this.on(event, func, context);
    }

    removeOver(func, context) {
        this.removeListener(this._onOverEvent, func, context);
    }

    removeOut(func, context) {
        this.removeListener(this._onOutEvent, func, context);
    }

    removeDown(func, context) {
        this.removeListener(this._onDownEvent, func, context);
    }

    removeUp(func, context) {
        this.removeListener(this._onUpEvent, func, context);
    }

    removeUpOutSide(func, context) {
        this.removeListener(this._onUpOutSideEvent, func, context);
    }

    removeDragUpdate(func, context) {
        this.removeListener(this._onDragUpdateEvent, func, context);
    }

    removeDragStart(func, context) {
        this.removeListener(this._onDragStartEvent, func, context);
    }

    removeDragStop(func, context) {
        this.removeListener(this._onDragStopEvent, func, context);
    }

//---------------------------------------
/// ACCESSOR
//--------------------------------------

    set isUpdate(value) {
        if (!this._isUpdate && value) {
            Omy.addUpdater(this.update, this);
        } else if (this._isUpdate && !value) {
            Omy.removeUpdater(this.update, this);
        }
        this._isUpdate = value;
    }

    get isUpdate() {
        return this._isUpdate;
    }

    get active() {
        return this._active;
    }

    get scaleX() {
        return this.scale.x;
    }

    set scaleX(value) {
        this.scale.x = value;
    }

    get scaleY() {
        return this.scale.y;
    }

    set scaleY(value) {
        this.scale.y = value;
    }

    get pivotX() {
        return this.pivot.x;
    }

    set pivotX(value) {
        this.pivot.x = value;
    }

    get pivotY() {
        return this.pivot.y;
    }

    set pivotY(value) {
        this.pivot.y = value;
    }

    set anchorX(value) {
        this._anchorX = value;
        this.pivot.x = value * this.width / this.scale.x;
    }

    get anchorX() {
        return this._anchorX;
    }

    set anchorY(value) {
        this._anchorY = value;
        this.pivot.y = value * this.height / this.scale.y;
    }

    get anchorY() {
        return this._anchorY;
    }

    get localLeft() {
        return this._localBoundsRect.left;
    }

    get localRight() {
        return this._localBoundsRect.right;
    }

    get localTop() {
        return this._localBoundsRect.top;
    }

    get localBottom() {
        return this._localBoundsRect.bottom;
    }

    get localWidth() {
        return this._localBoundsRect.width;
    }

    get localHeight() {
        return this._localBoundsRect.height;
    }

    get globalLeft() {
        return this.getGlobalPosition().x + this.localLeft;
    }

    get globalTop() {
        return this.getGlobalPosition().y + this.localTop;
    }

    get worldX() {
        return this.getGlobalPosition().x;
    }

    get worldY() {
        return this.getGlobalPosition().y;
    }

    get x() {
        this._oX = super.x;
        return this._oX;
    }

    set x(value) {
        super.x = this._oX = value;
    }

    get y() {
        this._oY = super.y;
        return this._oY;
    }

    set y(value) {
        super.y = this._oY = value;
    }

    get height() {
        this._oHeight = super.height;
        return this._oHeight;
    }

    set height(value) {
        return super.height = this._oHeight = value;
    }

    get width() {
        this._oWidth = super.width;
        return this._oWidth;
    }

    set width(value) {
        return super.width = this._oWidth = value;
    }

    get oType() {
        return this._oType;
    }

    get input() {
        return this._isCheckInput;
    }

    set input(value) {
        if (this.input) {
            this.interactive = value;
        } else if (value) {
            this._isCheckInput = true;
            this.interactive = true;
            this.on("pointerdown", this._down, this);
            this.on("pointerup", this._up, this);
            this.on("pointerupoutside", this._upOutSide, this);
            this.on("pointerover", this._over, this);
            this.on("pointerout", this._out, this);
        }
    }

    set drag(value) {
        if (!this.input)
            this.input = true;

        if (!this._isUpdate) this.isUpdate = true;

        this._isDrag = value;
        this._listenMouseUp = value;
        (this._listenMouseUp) ? Omy.mouse.addUpHandler(this._globalMouseUp, this) : Omy.mouse.removeUpMouse(this._globalMouseUp, this);
        this._dragVertical = true;
        this._dragHorizontal = true;
    }

    set allowHorizontalDrag(value) {
        this._dragHorizontal = value;
    }

    set allowVerticalDrag(value) {
        this._dragVertical = value;
    }

    set interactChild(value) {
        this.interactiveChildren = value;
    }
}
